var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"con-box"},[_c('div',{staticClass:"foot-item"},[_vm._v("主办单位：灵武市科学技术局")]),_c('div',{staticClass:"foot-item"},[_vm._v("单位地址：银川市灵武市东塔镇灵武电商创业园附近（邮编:751400）")]),_c('div',{staticClass:"foot-item"},[_c('span',[_vm._v("宁ICP备16001670号")])])])])
}]

export { render, staticRenderFns }